import { Component, OnInit } from '@angular/core';
import { ProfileMenuDto } from 'src/app/core/data-models/resource.data-models';
import { ResourceDataService } from 'src/app/core/data-services/resource/resource-data.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { TenantConfigService } from 'src/app/shared/services/tenant-config.service';

@Component({
  selector: 'app-simple-footer',
  templateUrl: './simple-footer.component.html',
  styleUrls: ['./simple-footer.component.scss']
})
export class SimpleFooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  companyName: string = '';
  baseUrl = 'faq/';
  menus: ProfileMenuDto[] = [];
  logoUrl: string = '';

  constructor(
    private resourceDataService: ResourceDataService,
    public languageService: LanguageService,
    private tenantConfigService: TenantConfigService
  ) {
    this.companyName = localStorage.getItem('currentLang') === 'ar' && this.tenantConfigService.tenant.companyNameAr ? this.tenantConfigService.tenant.companyNameAr : this.tenantConfigService.tenant.companyName;
    this.logoUrl = this.tenantConfigService.tenant.coloredLogoUrl;
  }

  ngOnInit(): void {
    this.resourceDataService.GetProfileMenu().subscribe({
      next: (res) => {
        this.menus = res;
      }
    });
  }
}
